import { useAppSelector } from '@repo/store/maps/hooks';
import { selectFeatureFlag } from '@repo/store/maps/slices/featureFlags';

export function useMapCompassEnabled(): boolean {
    return useAppSelector(selectFeatureFlag('maps_compass')) !== undefined;
}
